// Test IDs for the active workout session UI (Phase 04).

export const SESSION = {
    root: 'session-root',
    title: 'session-title',
    elapsed: 'session-elapsed',
    finishBtn: 'session-finish-btn',
    finishConfirm: 'session-finish-confirm',
    notFound: 'session-not-found',
    summary: 'session-summary',
    backToWorkouts: 'session-back-to-workouts',
    restTimer: 'session-rest-timer',
    restReset: 'session-rest-reset',
    addExerciseBtn: 'session-add-exercise-btn',
    exerciseCard: 'session-exercise-card', // -{exercise_id}
    addSetBtn: 'session-add-set-btn',       // -{exercise_id}
    setRow: 'session-set-row',              // -{set_id}
    weightInput: 'session-weight-input',    // -{set_id}
    repsInput: 'session-reps-input',        // -{set_id}
    rpeSelect: 'session-rpe-select',        // -{set_id}
    warmupToggle: 'session-warmup-toggle',  // -{set_id}
    completeBtn: 'session-complete-btn',    // -{set_id}
    uncompleteBtn: 'session-uncomplete-btn', // -{set_id}
    deleteSetBtn: 'session-delete-set-btn', // -{set_id}
    prefillBadge: 'session-prefill-badge',  // -{set_id}
    prBadge: 'session-pr-badge',            // -{set_id}
};
